import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  Stack,
} from "@mui/material";

interface Props {
  stateDialogLive: {
    estado: boolean;
    tipo: number;
  };
  handleClose: (stateDialogLive: { estado: boolean; tipo: number }) => void;
}

const Channel =
  "https://www.youtube.com/embed/live_stream?channel=UCt4NgEmfSs7x_c8ucw7CcXw&autoplay=1&autohide=1&fs=1&rel=0&hd=1&wmode=transparent&enablejsapi=1&html5=1&showinfo=0";

const DialogContentLive = (props: Props) => {
  const { handleClose } = props;

  return (
    <>
      <DialogContent style={{ minWidth: "53rem", minHeight: "100%" }}>
        <div
          style={{
            width: "34rem",
            height: "27rem",
            minWidth: "100%",
            minHeight: "100%",
          }}
        >
          <iframe
            className="embed-responsive embed-responsive-item"
            src={`${Channel}`}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            loading="lazy"
            allowFullScreen
          ></iframe>
        </div>
      </DialogContent>
      <DialogActions>
        <Stack direction={"row"}>
          <Box m={1}>
            <Button
              color="error"
              variant="outlined"
              autoFocus
              onClick={() =>
                handleClose({
                  estado: false,
                  tipo: 2,
                })
              }
            >
              cerrar
            </Button>
          </Box>
        </Stack>
      </DialogActions>
    </>
  );
};

export default DialogContentLive;
